







helpers = require('../../../helpers.coffee')
view_model = {
  props: ['service_status', 'message']

  computed:
    show: ->
      @service_status == 'exceeded' || @service_status == 'exceeding'

    css_class: ->
      switch @service_status
        when 'exceeded' then 'alert-red'
        when 'exceeding' then 'alert-orange'
        else ''

  mounted: ->
    Tooltip.initialize()
}
exports.default = helpers.vue_include(view_model)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/header_actions/alert_tick.vue